module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-03@2x.228ccd7c.jpg";